import styles from './audio-player.module.scss';

interface IAudioPlayer {
  src: string;
}

export default function AudioPlayer({ src }: IAudioPlayer) {
  return (
    <audio
      className={styles['audio-player']}
      controls
      preload="metadata"
      src={src}
      data-testid="attached-data-audio"
    />
  );
}
